/**
 * Pill — a small rounded label. Used for status, category, and other one-word
 * descriptors. The caller passes the tone classes (e.g.
 * "bg-amber-50 text-amber-800 ring-amber-200").
 */

import React from 'react';

export default function Pill({ tone = 'bg-slate-100 text-slate-700 ring-slate-200', children }) {
  return (
    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-[12px] font-medium ring-1 ${tone}`}>
      {children}
    </span>
  );
}
